import React from 'react';
import { FaUser, FaStopwatch, FaTasks, FaUsers, FaCalendar, FaMoneyBillAlt, FaBuilding, FaTruck, FaChartArea, FaFileInvoice, FaDollarSign, FaUserTie, FaHeadset, FaTag, FaBars, FaTimes, FaHistory, FaVial, FaPlane, FaKey, FaPencilAlt, FaClipboardCheck } from 'react-icons/fa';
import { FiHeadphones } from 'react-icons/fi';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { getAuthPerfil, getAuthForPath, clearParticipantAuth, isParticipantPublicRoute, isParticipantSession } from '../util/authSession';
import { getText } from '../util/translations';
import { isAmbienteTeste } from '../util/ambiente';
import api from '../services/api';
import logo from '../images/logoaccess.png';
import '../css/financeiro-parcela-pagar.css';

const SUPORTE_URL = 'https://script.google.com/macros/s/AKfycbx4wsgEjszt0q0r7Lqa9e6v_eXyoMAhFeBNhYiafcX3FXFEv0BKLnjxSGrV66ZJ0C1iDA/exec';

// Estrutura do menu por seção (Divisões). As listas de perfis são as mesmas validações
// que existiam antes — apenas reorganizadas em dados. Item só aparece se o perfil casar.
const SECOES = [
    {
        titulo: 'Operação',
        itens: [
            { to: '/graficos', icon: <FaChartArea size={18} />, label: 'Gráficos', roles: ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'gerentersvp', 'coordenadorrsvp'] },
            { to: '/evento', icon: <FaCalendar size={18} />, label: 'Eventos', roles: ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp', 'rsvp', 'operadorrsvp', 'listarsvp', 'evento', 'backoffice', 'suplier', 'backofficeinterno', 'criacao', 'aereo', 'gerenteaereo'] },
            { to: '/aereo', icon: <FaPlane size={18} />, label: 'Aéreo', roles: ['admin', 'aereo', 'gerenteaereo'] },
            { to: '/rascunhoMalhaAereo', icon: <FaPencilAlt size={18} />, label: 'Rascunho de Malha', roles: ['admin', 'aereo', 'gerenteaereo'] },
            { to: '/backoffice', icon: <FaClipboardCheck size={18} />, label: 'Backoffice', roles: ['admin', 'backoffice'] },
            { to: '/cadastroEventoParticipanteOperador', icon: <FiHeadphones size={18} />, label: 'RSVP', roles: ['admin', 'gerenteprojeto', 'gerentersvp', 'coordenadorrsvp', 'rsvp', 'operadorrsvp'] },
            { to: '/eventoLiberarStartRsvp', icon: <FaCalendar size={18} />, label: 'Liberar Start RSVP', roles: ['backoffice'] },
            // `dinamico` marca item cuja visibilidade não cabe em lista de perfis: quem vê o painel
            // de SLA é quem é destinatário de algum alerta. Resolvido em runtime — ver temSla abaixo.
            { to: '/painelSla', icon: <FaTasks size={18} />, label: 'Pendências', roles: [], dinamico: 'sla' },
        ],
    },
    {
        titulo: 'Cadastros',
        itens: [
            { to: '/cliente', icon: <FaUsers size={18} />, label: 'Clientes', roles: ['admin', 'diretor', 'gerenteprojeto', 'suplier'] },
            { to: '/pessoa', icon: <FaUser size={18} />, label: 'Usuários', roles: ['rh', 'admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'gerentersvp', 'gerenteevento', 'gerenteeventointernacional', 'coordenadorrsvp'] },
            { to: '/fornecedor', icon: <FaTruck size={18} />, label: 'Fornecedor', roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'suplier'] },
            { to: '/participanteCategoria', icon: <FaTag size={18} />, label: 'Categorias Fornecedor', roles: ['admin', 'diretor', 'gerenteprojeto'] },
            { to: '/freelancer', icon: <FaUserTie size={18} />, label: 'Freelancers', roles: ['backofficeinterno'] },
            { to: '/empresa', icon: <FaBuilding size={18} />, label: 'Empresas', roles: ['admin', 'gerenteprojeto', 'gerentefinanceiro'] },
        ],
    },
    {
        titulo: 'Financeiro',
        itens: [
            { to: '/financeiro', icon: <FaMoneyBillAlt size={18} />, label: 'Financeiro', roles: ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'] },
            { to: '/solicitarGasto', icon: <FaDollarSign size={18} />, label: 'Solicitar gasto', roles: ['rh', 'admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento', 'gerenteevento', 'gerenteeventointernacional', 'rsvp', 'listarsvp', 'evento', 'backoffice', 'suplier'] },
            { to: '/notaFiscal', icon: <FaFileInvoice size={18} />, label: 'Notas Fiscais', roles: ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro'] },
        ],
    },
    {
        titulo: 'Administração',
        itens: [
            // Critérios não entra no menu: expõe colunas do banco e é só admin. Chega-se a ele
            // pelo botão na parte superior do painel de SLA.
            { to: '/sla', icon: <FaStopwatch size={18} />, label: 'SLA', roles: ['admin', 'diretor'] },
            { to: '/auditLog', icon: <FaHistory size={18} />, label: 'Registro de Auditoria', roles: ['admin'] },
            // Só fora do dashboard (produção), como a rota em routes.js.
            ...(isAmbienteTeste() ? [{ to: '/qaTestes', icon: <FaVial size={18} />, label: 'Testes QA', roles: ['admin'] }] : []),
            { to: '/acesso', icon: <FaKey size={18} />, label: 'Permissões de Acesso', roles: ['admin'] },
        ],
    },
];

/**
 * Cache em memória, chaveado pelo token — NÃO em storage.
 *
 * A sidebar não vive acima do <Switch>: cada página monta o próprio ErpTemplate, então trocar de
 * rota desmonta e remonta este hook. Sem cache sairia um GET por navegação e o item "Pendências"
 * piscaria a cada tela.
 *
 * Variável de módulo em vez de sessionStorage porque some no reload e não exige limpar em ponto
 * nenhum. A chave ser o token é o que impede o vazamento entre usuários: outro login = outro token
 * = cache ignorado, sem depender de alguém lembrar de invalidar no logout.
 */
let cacheAcesso = { token: null, tem: null };

/** O usuário enxerga o painel de Pendências? */
function useTemSla(perfil, token) {
    // Convidado nunca tem SLA, e a sidebar RENDERIZA para ele em algumas telas finais do fluxo
    // (convite concluído, contrato enviado, convite recusado, assinatura). Sem esta guarda, um
    // token interno esquecido no localStorage da máquina — comum em micro de operador — faria a
    // consulta sair pelo usuário errado e pintar o item no menu do convidado. Os outros itens não
    // têm o furo porque filtram por lista de perfis, que nunca casa com 'cliente'; este pergunta
    // ao servidor, então precisa perguntar pela pessoa certa.
    const convidado = isParticipantSession();
    const macro = !convidado && ['admin', 'diretor'].includes(perfil);

    // Já sabemos? Então o item nasce no estado certo e não pisca no remount.
    const cacheado = (!convidado && token && cacheAcesso.token === token) ? cacheAcesso.tem : null;
    const [tem, setTem] = React.useState(macro || cacheado === true);

    React.useEffect(() => {
        // Admin e diretor sempre enxergam, então nem consultam. Com cache válido, idem.
        if (convidado || macro || !token || cacheAcesso.token === token) return;

        api({ method: 'get', action: '/sla/dashboard/acesso', token })
            .then((response) => {
                const valor = !!(response.data.data?.tem);
                cacheAcesso = { token, tem: valor };
                setTem(valor);
            })
            // Falha na consulta esconde o item em vez de mostrar quebrado: o menu não é lugar de
            // reportar erro. NÃO cacheia o erro — a próxima navegação tenta de novo.
            .catch(() => setTem(false));
        // eslint-disable-next-line
    }, [convidado, macro, token]);

    return tem === true;
}

export default function SideBar({ recolhido = false, onToggle }) {
    const location = useLocation();
    const history = useHistory();
    const perfil = getAuthPerfil();
    const path = location.pathname;
    // getAuthForPath e não localStorage: o perfil acima já é ciente da rota, e ler o token de
    // outro lugar faria os dois descreverem pessoas diferentes na sessão de participante.
    const temSla = useTemSla(perfil, getAuthForPath().token);

    const podeVer = (item) => (item.dinamico === 'sla' ? temSla : item.roles.includes(perfil));
    const logomarcaEvento = (() => { try { return localStorage.getItem('logomarcaEvento'); } catch (e) { return null; } })();
    const logoSrc = (['cliente'].includes(perfil) && logomarcaEvento) ? logomarcaEvento : logo;
    const nomeUsuario = getAuthForPath().nomeUsuario;
    const [userMenu, setUserMenu] = React.useState(false);
    const [showSuporte, setShowSuporte] = React.useState(false);
    const logout = () => {
        clearParticipantAuth();
        if (!isParticipantPublicRoute()) {
            localStorage.removeItem('token');
            localStorage.removeItem('empresa');
            localStorage.removeItem('empresas');
        }
        history.push('/login');
    };

    return (
        <aside className={'access-sidebar no-print' + (recolhido ? ' recolhido' : '')}>
            <div className="as-top">
                <Link to="/" className="as-logo" title="Ir para a página inicial">
                    <img src={logoSrc} alt="ACCESS" />
                </Link>
                <button type="button" className="as-toggle" onClick={onToggle} title={recolhido ? 'Expandir menu' : 'Recolher menu'}>
                    <FaBars size={18} />
                </button>
            </div>

            <nav className="as-nav">
                {SECOES.map((sec) => {
                    const visiveis = sec.itens.filter((it) => podeVer(it));
                    if (visiveis.length === 0) return null;
                    return (
                        <div className="as-secao" key={sec.titulo}>
                            <div className="as-secao-titulo">{sec.titulo}</div>
                            {visiveis.map((it) => (
                                <Link
                                    key={it.to}
                                    to={it.to}
                                    title={it.label}
                                    className={'as-item' + (path === it.to ? ' ativo' : '')}
                                >
                                    <span className="as-icon">{it.icon}</span>
                                    <span className="as-label">{it.label}</span>
                                </Link>
                            ))}
                        </div>
                    );
                })}

                {/* Ajuda — Suporte (sempre visível) */}
                <div className="as-secao">
                    <div className="as-secao-titulo">Ajuda</div>
                    <button
                        type="button"
                        className="as-item"
                        title="Suporte"
                        onClick={() => setShowSuporte(true)}
                    >
                        <span className="as-icon"><FaHeadset size={18} /></span>
                        <span className="as-label">Suporte</span>
                    </button>
                </div>
            </nav>

            {/* Usuário (rodapé) */}
            <div className="as-user">
                {userMenu && (
                    <div className="as-user-menu">
                        {!['cliente'].includes(perfil) && (
                            <button type="button" className="as-user-item" onClick={() => history.push('/alterarSenha')}>Alterar Senha</button>
                        )}
                        <button type="button" className="as-user-item" onClick={logout}>{getText('logout') || 'Sair'}</button>
                    </div>
                )}
                <button type="button" className="as-user-btn" onClick={() => setUserMenu((v) => !v)} title={nomeUsuario || 'Usuário'}>
                    <span className="as-icon"><FaUser size={18} /></span>
                    <span className="as-label">{nomeUsuario || 'Usuário'}</span>
                </button>
            </div>

            {showSuporte && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                     onClick={(e) => { if (e.target === e.currentTarget) setShowSuporte(false); }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaHeadset size={17} /></span>
                                <h3 className="fin-pp__modal-title">Suporte
                                    <span className="fin-pp__modal-sub">Abra um chamado para o time de suporte</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setShowSuporte(false)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body" style={{ padding: 0 }}>
                                <iframe
                                    title="Suporte"
                                    src={SUPORTE_URL}
                                    style={{ width: '100%', height: '70vh', border: 'none', display: 'block' }}
                                >
                                    Carregando…
                                </iframe>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <span className="fin-pp__modal-sub" style={{ marginRight: 'auto' }}>Não carregou?</span>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--primary"
                                    onClick={() => window.open(SUPORTE_URL, '_blank', 'noopener')}
                                >
                                    Abrir em nova aba
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </aside>
    );
}
